import * as React from 'react';
import LanguageSelect from '../../../Others/LanguageSelect';

export const Title = (props: any) => {
  return (
    <React.Fragment>
      <h2>
        {props.children}
        {props.languages && props.currentLanguage && props.onChange &&
          <LanguageSelect
            name={'language'}
            languages={props.languages}
            value={props.currentLanguage}
            onChange={(e: any) => props.onChange(props.languages.find((l) => l.id === e.target.value).value)}
            style={{ float: 'right', minWidth: '90px' }}
          />
        }
      </h2>
      {props.extra}
    </React.Fragment>
  );
};


// WEBPACK FOOTER //
// ./src/components/Layout/components/Title/Title.tsx